module.exports = __webpack_public_path__ + "assets/img/Type E (16).929f4568.jpg";